var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},_vm._l((_vm.groups),function(group){return _c('div',{staticClass:"mt-2"},[_c('h2',{staticClass:"text-lg"},[_vm._v(_vm._s(group.name))]),_c('ul',{staticClass:"list text-md mt-3"},_vm._l((group.items),function(preference){return _c('preference-item',{attrs:{"preference":preference}})}),1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }